import { defineMessages } from 'react-intl'

const messages = {
  header: {
    id: 'app.components.confirm-accept-declined-product.header',
    defaultMessage: 'This item can not be accepted since the order is ready for pickup.',
  },
  subheader: {
    id: 'app.components.confirm-accept-declined-product.subheader',
    defaultMessage: 'Click “Confirm” to move the order to the in-progress column and to accept the item',
  },
  confirm: {
    id: 'app.components.confirm-accept-declined-product.confirm',
    defaultMessage: 'Confirm',
  },
}

export default defineMessages(messages)
